/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsLegalContact } from './FxIdDomainSettingsPublicWebClientConfigOptionsLegalContact';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLegalContact,
    FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsLegalContact';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValue
 * 
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValue = FxIdDomainSettingsPublicWebClientConfigOptionsLegalContact;

export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValue {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValue {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLegalContact(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValueToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactsValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLegalContact(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLegalContactToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsLegalContact);
    }

    return {};
}

